import React from 'react';
export const IconFavorite16 = (props: Record<string, string>) => {
    return (
        <svg
            aria-label={props.ariaLabel}
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props.fill || 'none'}
                stroke={props.stroke || 'currentColor'}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M8.002 14.5 2.035 7.892a3.888 3.888 0 0 1-.99-2.057 3.93 3.93 0 0 1 .328-2.267v0A3.528 3.528 0 0 1 2.415 2.23a3.425 3.425 0 0 1 1.532-.682 3.39 3.39 0 0 1 1.667.131 3.454 3.454 0 0 1 1.412.914l.976 1.035.974-1.034c.39-.418.875-.731 1.412-.913a3.39 3.39 0 0 1 1.665-.131 3.43 3.43 0 0 1 1.532.681c.448.352.806.81 1.041 1.336v0c.332.704.447 1.494.329 2.267a3.885 3.885 0 0 1-.99 2.056L8.002 14.5Z"
            />
        </svg>
    );
};
